import React from 'react';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import IconServeceo from 'components/icons/iconServeceo';
import AffirmUpholsteryUpCharge from 'components/consumer/user-order-materials/components/AffirmUpholsteryUpCharge/AffirmUpholsteryUpCharge';
import CustomerDashboardPageTemplate from 'components/consumer/CustomerDashboardPageTemplate';
import UserProtectionPlans from './components/UserProtectionPlans/UserProtectionPlans';

export const getAffirmReturnParams = search => {
  const params = queryString.parse(search);
  const str = search ? search.split('?').pop() : '';
  if (str) {
    const [emailParam] = str.split('&').filter(p => p.includes('email='));
    if (emailParam) {
      const emailValue = emailParam.split('=').pop();
      if (emailValue) {
        params.email = decodeURIComponent(emailValue);
      }
    }
  }
  return params;
};

const UserProtectionPlansContainer = () => {
  const { search } = useLocation();
  const {
    oid,
    cid,
    email,
    product,
    plan_id,
    cart_id,
    plan_name,
    payment_token,
    checkout_token,
  } = getAffirmReturnParams(search);

  if (checkout_token && payment_token) {
    return (
      <AffirmUpholsteryUpCharge
        email={email}
        order_id={oid}
        customer_id={cid}
        cart_id={cart_id}
        plan_id={plan_id}
        plan_name={plan_name}
        product_name={product}
        payment_token={payment_token}
        checkout_token={checkout_token}
      />
    );
  }

  return (
    <div data-xc="user-protection-plans">
      <CustomerDashboardPageTemplate
        title="Protection Plans"
        titleComponent={
          <div className="w-[740px] flex flex-row justify-between max-[1023px]:w-[500px] max-[1023px]:m-auto max-[1023px]:flex-col max-[500px]:w-[90vw]">
            <div className="text-3xl font-bold">Protection Plans</div>
            <div className="text-base font-bold max-[1023px]:mt-4">
              <span>{` In partnership with  `}</span>
              <IconServeceo />
            </div>
          </div>
        }
      >
        <div className="w-[740px] max-[1023px]:w-[500px] max-[1023px]:m-auto max-[500px]:w-[90vw]">
          <UserProtectionPlans />
        </div>
      </CustomerDashboardPageTemplate>
    </div>
  );
};

export default UserProtectionPlansContainer;
